import React from 'react'
import Button from '../../../../../../../Components/Buttons/Button'
import VideoRecord from '../../../../../../../Modules/videoRecord'
import { SecondStepEl } from '../Elements'
import GroupRegistrationStore from '../Store/GroupRegistrationStore'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace'
import ReactPlayer from 'react-player'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'
import { H4 } from '../../../../../../../Styles/typography'

function SecondStep() {
  const {
    setSelBatch,
    next,
    back,
    setVideoBlob,
    videoBlob,
  } = GroupRegistrationStore.useContainer()
  return (
    <>
      <div
        className='back-btn'
        onClick={() => {
          back()
          setSelBatch(null)
        }}
      >
        <KeyboardBackspaceIcon /> Back
      </div>
      <SecondStepEl>
        <H4>Upload an audition video:</H4>
        <div className='video-container'>
          {videoBlob ? (
            <>
              <ReactPlayer
                url={URL.createObjectURL(videoBlob)}
                controls
                playing
                width={'100%'}
              />
              <div className='action-btns'>
                <div className='retake-btn' onClick={() => setVideoBlob(null)}>
                  <DeleteOutlineIcon /> Retake
                </div>
                <Button type='primary' onClick={() => next()} name='Proceed' />
              </div>
            </>
          ) : (
            <VideoRecord
              onSubmit={(value) => setVideoBlob(value)}
              videoBlob={videoBlob}
              size_limit={50 * 1024 * 1024}
              maxDuration={2.5 * 60 * 1000}
            />
          )}
        </div>
      </SecondStepEl>
    </>
  )
}

export default SecondStep
